/**
 * AttackListGeneratorControl
 *
 * 「今攻めるべきリスト自動生成」機能のサイドバーコントロール。
 * ExecListSidebarの上部に表示され、クリックするとAttackListGeneratorDialogを開く。
 *
 * ## 機能概要
 * - LPやウェブページのURLを入力すると、AIがページ内容を解析
 * - ターゲットとなるキーマンを自動抽出してタグ付け
 * - 最大1000件のキーマンをリスト化
 *
 * ## 関連コンポーネント
 * - AttackListGeneratorDialog: URL入力・解析結果表示のダイアログ
 * - ExecListSidebar: このコントロールを表示する親コンポーネント
 *
 * ## バックエンド
 * - AttackListAnalyzerService: 解析・タグ付けのビジネスロジック
 */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import Button from '../../Parts/Button';
import Thunder from '../../Icons/Thunder';

const styles = () => ({
  root: {
    width: '100%',
    padding: '15px',
    marginBottom: '20px',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    borderRadius: '8px',
    boxSizing: 'border-box',
  },

  title: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '10px',
    color: '#FFFFFF',
    fontWeight: 'bold',
    fontSize: '13px',
  },

  description: {
    fontSize: '12px',
    color: 'rgba(255, 255, 255, 0.9)',
    marginBottom: '12px',
    lineHeight: '1.5',
  },
});

class AttackListGeneratorControl extends React.Component {
  render() {
    const { classes, onClick } = this.props;

    return (
      <div className={classes.root}>
        <div className={classes.title}>
          <Thunder width={16} height={16} color="#FFFFFF" style={{ marginRight: '8px' }} />
          今攻めるべきリスト自動生成
        </div>
        <Typography className={classes.description}>
          LPやウェブページのURLを入力するだけで、AIがターゲットキーマンを自動抽出します。
        </Typography>
        <Button
          text="URLから自動生成"
          handleClickButton={onClick}
          fullWidth={true}
          style={{
            background: '#FFFFFF',
            color: '#667eea',
            fontWeight: 'bold',
          }}
        />
      </div>
    );
  }
}

AttackListGeneratorControl.propTypes = {
  classes: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default withStyles(styles)(AttackListGeneratorControl);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/controls/AttackListGeneratorControl.jsx